import request from "../utils/request"

export const me = () => request.get("/me")

export const updateAuth = data => request.put("/me", data)

export const billingPortal = () => request.get("/billing-portal")

/*
 * Stop viewing as another account -- a child, an adult student or a parent --
 * and get the admin's own session back
 * (../wicked-maths-laravel/docs/VIEW_AS_USER.md).
 *
 * Deliberately NOT under /admin: when this is called the session IS that
 * account, so the admin-only routes would refuse the one request that ends the
 * impersonation. It answers { data: { token, user }, viewing_as: null } -- the
 * token is the admin's, to be swapped back in.
 */
export const stopViewAs = () => request.post("/view-as/stop", {})

/*
 * "Re-check now" from INSIDE a View As session
 * (../wicked-maths-laravel/docs/SCHEDULED_WORK.md §10, docs/VIEW_AS_USER.md §1).
 *
 * Evaluates the automatic release rules again for the account being viewed and
 * opens whatever it is already owed. Answers { data: { user_id, areas_opened } }.
 *
 * NO ID, and that is the endpoint's contract rather than a convenience here: it
 * acts on the token's own subject, so there is nothing for a caller to tamper
 * with and no way to reach another account from inside one session. Do not add
 * an argument.
 *
 * It sits beside stopViewAs and NOT under /admin for the same reason that one
 * does: while a View As session is live the SPA holds one bearer token, the
 * child's, so every /api/admin/* route answers 403. The global Authorization
 * header is already the right one -- there is no token juggling to do here.
 *
 * It can only ever OPEN work, never close it, it does nothing the account's own
 * next content read would not, and it is idempotent, so a second press opens
 * nothing. That is what makes it safe to offer on a banner that sits over every
 * screen.
 */
export const recheckWhileViewingAs = () => request.post("/view-as/recheck", {})
